export function AddVideo(organizationID: number, gameID: number, videoID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/videos/${videoID}`;
}

export function CreateGameReport(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/game-report`;
}

export function CreateModel(sportType: string): string {
	return `/v1/sports/${sportType}/games/create-model`;
}

export function DashboardModel(organizationID: number): string {
	return `/v1/organizations/${organizationID}/games/dashboard`;
}

export function DeleteGameReport(organizationID: number, gameID: number, gameReportID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/game-report/${gameReportID}`;
}

export function DeleteVideo(organizationID: number, gameID: number, videoID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/videos/${videoID}`;
}

export function EventsSummary(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/events/summary`;
}

export function Formations(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/formations`;
}

export function GameHistory(organizationID: number): string {
	return `/v1/organizations/${organizationID}/games/game-history`;
}

export function GameStatsSummary(organizationID: number): string {
	return `/v1/organizations/${organizationID}/games/game-stats-summary`;
}

export function GenerateTimePlayed(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/time-played/generate`;
}

export function IndexGameReport(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/game-report`;
}

export function List(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/games`;
}

export function ListCompetitions(organizationID: number): string {
	return `/v1/organizations/${organizationID}/games/competitions`;
}

export function ListEvents(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/events`;
}

export function ListJerseyNumbers(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/jersey-numbers`;
}

export function ListLastGames(organizationID: number): string {
	return `/v1/organizations/${organizationID}/games/last-games`;
}

export function ListTeamUsers(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/users`;
}

export function ListVideos(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/videos`;
}

export function PlayerStatistics(organizationID: number): string {
	return `/v1/organizations/${organizationID}/games/player-statistics`;
}

export function SetupModel(sportType: string): string {
	return `/v1/sports/${sportType}/games/setup-model`;
}

export function TeamLineup(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/lineup`;
}

export function TimePlayed(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/time-played`;
}

export function UpdateEvents(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/events`;
}

export function UpdateGameReport(organizationID: number, gameID: number, gameReportID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/game-report/${gameReportID}`;
}

export function UpdateJerseyNumbers(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/jersey-numbers`;
}

export function UpdateResult(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/result`;
}

export function UpsertTeamLineup(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/lineup`;
}

export function UpsertTimePlayed(organizationID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/games/${gameID}/time-played`;
}

